import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#loesung", label: "Lösung" },
  { href: "#kameramast", label: "Kameramast" },
  { href: "#anschlusskasten", label: "Anschlusskasten" },
  { href: "#vorteile", label: "Vorteile" },
  { href: "#anwendungen", label: "Anwendungen" },
  { href: "#technik", label: "Technik" },
  { href: "#dokumente", label: "Dokumente" },
];

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-slate-200"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
      <div className="flex items-center">
        <a
          href="https://www.xortec.de"
          target="_blank"
          rel="noreferrer"
          data-testid="nav-logo"
          className="flex items-center gap-3 group"
          aria-label="Zur Xortec Hauptseite"
        >
          <img
            src={scrolled ? "/brand/xortec-logo.png" : "/brand/xortec-logo-light.png"}
            alt="Xortec"
            className="h-8 md:h-9 w-auto"
          />
        </a>
        <a
          href="https://kameramast.xortec.de"
          target="_blank"
          rel="noreferrer"
          data-testid="nav-qr"
          aria-label="QR-Code zu kameramast.xortec.de"
          title="kameramast.xortec.de"
          className="hidden sm:inline-flex items-center justify-center ml-3 transition-all"
        >
          <img
            src={scrolled ? "/brand/qr-kameramast-dark.png" : "/brand/qr-kameramast-light.png"}
            alt="QR-Code kameramast.xortec.de"
            className="h-10 w-10 md:h-11 md:w-11 block"
          />
        </a>
      </div>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className={`text-sm font-medium transition-colors ${
                scrolled
                  ? "text-slate-700 hover:text-[#0055A4]"
                  : "text-white/90 hover:text-white"
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="/konfigurator"
            data-testid="nav-cta-konfigurator"
            className="bg-[#0055A4] hover:bg-[#003e7a] text-white text-sm font-medium px-5 py-2.5 rounded-md transition-colors shadow-sm"
          >
            Konfigurator
          </a>
          <a
            href="#kontakt"
            data-testid="nav-cta-anfrage"
            className="bg-[#0055A4] hover:bg-[#003e7a] text-white text-sm font-medium px-5 py-2.5 rounded-md transition-colors shadow-sm"
          >
            Projekt anfragen
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className={`lg:hidden p-2 rounded-md ${
            scrolled ? "text-slate-900" : "text-white"
          }`}
          onClick={() => setOpen((o) => !o)}
          aria-label="Menü öffnen"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-panel"
          className="lg:hidden bg-white border-b border-slate-200 px-6 py-4 space-y-3"
        >
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block text-slate-700 hover:text-[#0055A4] text-sm font-medium"
            >
              {l.label}
            </a>
          ))}
          <a
            href="/konfigurator"
            onClick={() => setOpen(false)}
            className="block bg-[#0055A4] text-white text-sm text-center font-medium px-5 py-2.5 rounded-md"
          >
            Konfigurator
          </a>
          <a
            href="#kontakt"
            onClick={() => setOpen(false)}
            className="block bg-[#0055A4] text-white text-sm text-center font-medium px-5 py-2.5 rounded-md"
          >
            Projekt anfragen
          </a>
        </div>
      )}
    </header>
  );
}
